// extracted by mini-css-extract-plugin
module.exports = {"side":"catalog_side__22bOG"};